import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ReceivedCustomerOrdersPage } from "src/components/views/erp/sales/customerOrder/ReceivedCustomerOrdersPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/receivedCustomerOrders")({
	staticData: { title: i18n.t("received_customer_orders"), legacyViewKey: "receivedCustomerOrdersPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ReceivedCustomerOrdersPage />;
}
